import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import ContributorService from "../services/contributor.service";


import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0,
};

export const getContributors = createAsyncThunk(
  "Contributor/get_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await ContributorService.getContributors(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getContributorUi = createAsyncThunk(
  "Contributor/get_ui",
  async (_, thunkAPI) => {
    try {
      const data = await ContributorService.getContributorUi();
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createContributor = createAsyncThunk(
  "Contributor/create",
  async ({ contributor }, thunkAPI) => {
    try {
      const response = await ContributorService.createContributor(contributor);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateContributor = createAsyncThunk(
  "Contributor/update",
  async ({ contributor }, thunkAPI) => {
    try {
      const response = await ContributorService.updateContributor(contributor);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteContributor = createAsyncThunk(
  "Contributor/delete",
  async ({ id }, thunkAPI) => {
    try {
      await ContributorService.deleteContributor(id);
      thunkAPI.dispatch(setMessage({ message: "Contributor deleted successfully", type: "success" }));
      return { id };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);



const initialState = {
  data: list,
  ui: {
    columns: [],
    columnsVisability: {},
    sort: "",
  },
  loading: false,
}

const ContributorSlice = createSlice({
  name: "Contributor",
  initialState,

  extraReducers: {

    [getContributors.pending]: (state) => {
      state.loading = true;
    },
    [getContributors.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
    },
    [getContributors.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },

    [getContributorUi.pending]: (state) => {
      state.loading = true;
    },
    [getContributorUi.fulfilled]: (state, action) => {
      state.ui = action.payload.data;
      state.loading = false;
    },
    [getContributorUi.rejected]: (state) => {
      state.loading = false;
    },

  },
});

const { reducer } = ContributorSlice;
export default reducer;
